import Spinner from 'common/spinner';
import useCurrentUser from 'utils/useCurrentUser';

const Profile = () => {
  const currentUser = useCurrentUser();

  if (!currentUser) {
    return <Spinner />;
  }

  return <>{`${currentUser.firstName} ${currentUser.lastName}'s Profile`}</>;
};

export default Profile;
